import { apiHelper } from "./core"
const baseUrl = process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const baseUrlResource = process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL,
  masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL
const resourceServiceBaseUrl =
  process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL
const userServiceBaseUrl = process.env.REACT_APP_USER_MANAGEMENT_BASE_URL

const raiseFileRequisitionRequest = (info: any): Promise<any> => {
  return apiHelper
    .post(masterServiceBaseUrl + `/mrd/request`, info)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getPatientDocumentsList = (id: any): Promise<any> => {
  return apiHelper
    .get(userServiceBaseUrl + `/patients/${id}/document-names`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const renewFileRequisitionRequest = (id: any): Promise<any> => {
  return apiHelper
    .post(masterServiceBaseUrl + `/mrd/renew/${id}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getRasiedRequestsById = (id: any): Promise<any> => {
  return apiHelper
    .get(masterServiceBaseUrl + `/mrd/${id}/all`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getApprovalPendingRasieRequests = (): Promise<any> => {
  return apiHelper
    .get(masterServiceBaseUrl + `/mrd/requests`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getDiscountPendingRasieRequests = (url: any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/${url}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getDiscountPendingRaiseRequests = (): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/discount-approvals`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getDiscountPendingRaiseRequestsByID = (id:any): Promise<any> => {
  return apiHelper
    .get(`${resourceServiceBaseUrl}/discount-approvals/${id}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}


const getChemoPendingRasieRequests = (url:any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/${url}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getChemoApprovalsList = (url:any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/${url}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const updateDiscountPendingRaiseRequest = (
  id: any,
  values: any
): Promise<any> => {
  return apiHelper
    .put(resourceServiceBaseUrl + `/discount-approvals/${id}`, values)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const updateChemoOrderPendingRequest = (
  id: any,
  values: any
): Promise<any> => {
  return apiHelper
    .patch(baseUrl + `/chemo-order/${id}/action`, values)
    .then((res: any) => {
      return res?.data
    })
    .catch((error: any) => {
      return Promise.reject(error)
    })
}

const savePendingApprovalRequest = (type: any, id: any, payload: any): Promise<any> => {
  return apiHelper
    .post(masterServiceBaseUrl + `/mrd/${type}/${id}`, payload)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getMandatoryForms = (id: any): Promise<any> => {
  return apiHelper
    .get(baseUrlResource + `/appointments/${id}/mandatory-forms`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export {
  raiseFileRequisitionRequest,
  getPatientDocumentsList,
  renewFileRequisitionRequest,
  getRasiedRequestsById,
  getApprovalPendingRasieRequests,
  getChemoPendingRasieRequests,
  getMandatoryForms,
  savePendingApprovalRequest,
  getDiscountPendingRasieRequests,
  updateDiscountPendingRaiseRequest,
  updateChemoOrderPendingRequest,
  getChemoApprovalsList,
  getDiscountPendingRaiseRequests,
  getDiscountPendingRaiseRequestsByID,
}
